import React from 'react'

const ToastMsg = ({heading,msg}:any) => {
  return (
    <><span>{heading}</span>{msg ? msg : ''}</>
  )
}

export default ToastMsg
